// Please prefix all keys with `error` to not get confilcts with other translations.
export default {
	en: {
		navigationTop: 'top',
		navigationLeft: 'access main sections',
		navigationRight: '',
		navigationBottom: '',
		navigationTour: 'navigate tour',
		chapter: 'Drop-Down field',
		opened: 'opened',
		closed: 'closed',
		duration: 'duration',
		playVideo: 'play video',
		videoDescription: 'video description: ',
		playAudio: 'play audio',
		stopAudio: 'stop audio',
		description: 'description',
		title: 'title',
		attribution: 'attribution',
		images: 'images',
		imageTitle: 'Image title: ',
		imageDescription: 'Image Description: ',
		imageAttribution: 'Image Attribution: ',
		galleryOpen: 'Open gallery with ',
		galleryGoToImage: 'Go to image',
		image360Show: 'Open 360 degree image: ',
		model3dShow: 'Open 3d model: ',
		model3dDescription: 'Model description: ',
		model3dAttribution: 'Model attribution: ',
	},
	de: {
		chapter: 'Ausklapp-Feld',
		opened: 'geöffnet',
		closed: 'geschlossen',
		duration: 'Dauer',
		playVideo: 'spiele video',
		videoDescription: 'Video Beschreibung: ',
		playAudio: 'spiele audio',
		stopAudio: 'stoppe audio',
		description: 'Beschreibung',
		title: 'Titel',
		attribution: 'Zuschreibung',
		images: 'Bilder',
		imageTitle: 'Bild Titel: ',
		imageDescription: 'Bild Beschreibung: ',
		imageAttribution: 'Bild Zuschreibung: ',
		galleryOpen: 'Öffne Gallerie mit ',
		galleryGoToImage: 'Gehe zu Bild',
		image360Show: 'Öffne 360 Grad Bild: ',
		model3dShow: 'Öffne 3d Modell: ',
		model3dDescription: 'Modell Beschreibung: ',
		model3dAttribution: 'Modell Zuschreibung: ',
	},
	des: {
		chapter: 'Ausklapp-Feld',
		opened: 'geöffnet',
		closed: 'geschlossen',
		duration: 'Dauer',
		playVideo: 'spiele video',
		videoDescription: 'Video Beschreibung: ',
		playAudio: 'spiele audio',
		stopAudio: 'stoppe audio',
		description: 'Beschreibung',
		title: 'Titel',
		attribution: 'Zuschreibung',
		images: 'Bilder',
		imageTitle: 'Bild Titel: ',
		imageDescription: 'Bild Beschreibung: ',
		imageAttribution: 'Bild Zuschreibung: ',
		galleryOpen: 'Öffne Gallerie mit ',
		galleryGoToImage: 'Gehe zu Bild',
		image360Show: 'Öffne 360 Grad Bild: ',
		model3dShow: 'Öffne 3d Modell: ',
		model3dDescription: 'Modell Beschreibung: ',
		model3dAttribution: 'Modell Zuschreibung: ',
	},
	dec: {
		chapter: 'Ausklapp-Feld',
		opened: 'geöffnet',
		closed: 'geschlossen',
		duration: 'Dauer',
		playVideo: 'spiele video',
		videoDescription: 'Video Beschreibung: ',
		playAudio: 'spiele audio',
		stopAudio: 'stoppe audio',
		description: 'Beschreibung',
		title: 'Titel',
		attribution: 'Zuschreibung',
		images: 'Bilder',
		imageTitle: 'Bild Titel: ',
		imageDescription: 'Bild Beschreibung: ',
		imageAttribution: 'Bild Zuschreibung: ',
		galleryOpen: 'Öffne Gallerie mit ',
		galleryGoToImage: 'Gehe zu Bild',
		image360Show: 'Öffne 360 Grad Bild: ',
		model3dShow: 'Öffne 3d Modell: ',
		model3dDescription: 'Modell Beschreibung: ',
		model3dAttribution: 'Modell Zuschreibung: ',
	},
};
